// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"290":"component---src-templates-single-pokemon-js","352":"component---src-templates-pokemon-list-tsx"}[chunkId] + "-" + {"290":"714637d6de8c5a6c4f69","352":"654654034792651b13bc"}[chunkId] + ".js";
};